import React from "react";
import ScrollToTopOnMount from "../../../Components/ScrollToTop";
import ArticleSection from "./ArticleSection/Main";
import TopSection from "./TopSection/Main";

const JazzyBurger = () => {
  return (
    <>
      <ScrollToTopOnMount />
      <TopSection />
      <ArticleSection />
    </>
  );
};

export default JazzyBurger;
